import { render, staticRenderFns } from "./PanelBlueLabelPlayerBalance.vue?vue&type=template&id=526124ad&scoped=true&"
import script from "./PanelBlueLabelPlayerBalance.vue?vue&type=script&lang=js&"
export * from "./PanelBlueLabelPlayerBalance.vue?vue&type=script&lang=js&"
import style0 from "./PanelBlueLabelPlayerBalance.vue?vue&type=style&index=0&id=526124ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526124ad",
  null
  
)

export default component.exports